import React, {useEffect, useState} from 'react';
import OnboardInput from "../../component/base/onboard-input/OnboardInput";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import OnboardDialog from "../../component/base/onboard-dialog-component/OnboardDialog";
import NotNullCheck from "../../util/NotNullCheck";
import EndUseAgreementTTNETCheckbox from "../../component/custom/EndUseAgreementTTNETCheckbox";
import SeatOrTicketNumberComponent from "../../component/custom/SeatOrTicketNumberComponent";
import LoginStateManager from "../../util/LoginStateManager";
import VerifyTypeEnum from "../../enum/VerifyTypeEnum";
import {useSetRecoilState} from 'recoil';
import {informationAtom} from '../../store/InformationStore';

const LoginWithPromotionCode = (props) => {
    const {t, i18n} = props.props;
    const setInformation = useSetRecoilState(informationAtom);

    const [error, setError] = useState(null);
    const [dialogError, setDialogError] = useState({error: false, title: "", content: ""});

    const {loginOther} = new LoginStateManager(props.props, VerifyTypeEnum.OTHER_LOGIN);

    const validation = () => {
        if (NotNullCheck(control())) {
            loginOther(seatNumber, surname, ticketNumber, giftCouponCode, true)
        }
    }

    const control = () => {
        let valid = {
            surname: (surname == null || surname.length === 0) ? t('error.empty_surname') : null,
            ticketNumber: (ticketNumber == null || ticketNumber.length === 0) ? t('error.empty_ticket_number') : null,
            giftCouponCode: (giftCouponCode == null || giftCouponCode.length === 0) ? t('error.empty_gift_coupon_code') : null,
            seatNumber: (seatNumber == null || seatNumber.length === 0) ? t('error.empty_seat_number') : null,
            approve: (approve == null || !approve) ? t('error.empty_approve') : null,
        };
        if (seatNumber != null && seatNumber.length > 0) {
            valid.seatNumber = /^[\da-z]+$/i.test(seatNumber) ? null : t('error.valid_seat_number');
        }
        setError(valid);
        if (selectOption.value === "1") {
            valid.ticketNumber = null;
        } else {
            valid.surname = null;
            valid.seatNumber = null;
        }
        return valid;
    }

    useEffect(() => {
        if (error !== null) {
            control();
        }
    }, [i18n.language])

    const handleSelectOption = (e) => {
        setSelectOption(e);
        setError(null);
        setSeatNumber(null);
        setTicketNumber(null);

        setInformation(prev => ({
            ...prev,
            type: "login_type_" + (3 + parseInt(e.value))
        }));
    }

    const [selectOption, setSelectOption] = useState({value: '1', label: t('login.seat_number_option')});
    const [surname, setSurname] = useState(null);
    const [seatNumber, setSeatNumber] = useState(null);
    const [ticketNumber, setTicketNumber] = useState(null);
    const [giftCouponCode, setGiftCouponCode] = useState(null);
    const [approve, setApprove] = useState(null);

    return (
        <div>

            <SeatOrTicketNumberComponent changeSeatNumber={(e) => setSeatNumber(e)}
                                         changeTicketNumber={(e) => setTicketNumber(e)}
                                         errorSeatNumber={error?.seatNumber}
                                         errorTicketNumber={error?.ticketNumber}
                                         valueSeatNumber={seatNumber}
                                         valueTicketNumber={ticketNumber}
                                         changeOption={(e) => handleSelectOption(e)}>

                {selectOption.value === '1' && (
                    <>
                        <OnboardInput placeholder={t('login.surname')}
                                      onChange={(e) => setSurname(e)}
                                      error={error?.surname}
                                      upperAndEng length={30}
                                      value={surname}/>
                        <div className="h-8"/>
                    </>
                )}

            </SeatOrTicketNumberComponent>

            <div className="h-8"/>

            <OnboardInput placeholder={t('login.gift_coupon_code')} onChange={(e) => setGiftCouponCode(e)}
                          error={error?.giftCouponCode}
                          value={giftCouponCode}
                          length={10}/>

            <div className="h-20"/>

            <EndUseAgreementTTNETCheckbox value={approve}
                                          error={error?.approve}
                                          onChange={(e) => setApprove(e)}
                                          hiddenMilesAndSmiles
            />

            <div className="h-20"/>

            <OnboardButton label={t('login.login_btn')} onClick={() => validation()}/>

            <OnboardDialog error confirm
                           visible={dialogError.error}
                           title={t('connection_error_dialog.title')}
                           content={t('connection_error_dialog.content')}
                           confirmText={t('connection_error_dialog.confirm')}
                           onClickConfirm={() => console.log("Ok")}
                           cancelText={t('connection_error_dialog.cancel')} cancelShow
                           onClickCancel={() => setDialogError({...dialogError, error: false})}
            />

        </div>

    );
};

export default LoginWithPromotionCode;

